var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "d-flex flex-row align-items-center" }, [
      _c("div", { staticClass: "d-flex justify-content-start" }, [
        _c("div", { staticClass: "p-1" }, [
          _c("img", {
            staticClass: "round",
            attrs: {
              src:
                _vm.user.avatar !== null
                  ? _vm.user.avatar.url
                  : "/images/avatar.png",
              alt: "avatar",
              height: "30",
              width: "30",
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pl-0 pt-1 pr-1 pb-1" },
          [
            _c(
              "a",
              {
                staticClass: "text-bold-600",
                staticStyle: { color: "inherit" },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.user.first_name) +
                    " " +
                    _vm._s(_vm.user.last_name) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.user.badges, function (badge) {
              return _c("span", [
                _c("img", {
                  staticStyle: { "margin-top": "-3px", height: "15px" },
                  attrs: {
                    src: badge.image,
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: badge.name,
                    alt: "badge image",
                  },
                }),
              ])
            }),
            _vm._v(" "),
            _vm.user.user_badge_name !== null &&
            _vm.user.user_badge_icon !== null
              ? _c("img", {
                  staticStyle: { "margin-top": "-3px", height: "15px" },
                  attrs: {
                    src: _vm.user.user_badge_image.url,
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: _vm.user.user_badge_name,
                    alt: "badge image",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "font-small-2 text-muted" }, [
              _vm._v(
                _vm._s(_vm.user.position) +
                  "\n                    " +
                  _vm._s(
                    _vm.user.organisation !== null
                      ? "at " + _vm.user.organisation
                      : ""
                  ) +
                  "\n                "
              ),
            ]),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex p-1 ml-auto" }, [
        this.planId > 0
          ? _c("div", { staticClass: "ml-1" }, [
              _vm.isAdminButtonVisible
                ? _c(
                    "button",
                    {
                      staticClass: "btn waves-effect waves-light btn-sm",
                      class: {
                        "btn-success": !_vm.isAdminOfOrganisation,
                        "btn-danger": _vm.isAdminOfOrganisation,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleOrganisationAdminAssignment.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.assignmentAdminButtonText) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLocalOrganisationAdmin
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-danger btn-sm",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.removeAdminOfOrganisation.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Remove Admin\n                "
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }